import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import {
  FiCalendar,
  FiClock,
  FiEdit2,
  FiMoreVertical,
  FiTrash2,
  FiUsers,
} from "react-icons/fi";

function OfficeRowMenu({ disabled, onAppointments, onHours, onUsers, onEdit, onDelete }) {
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, right: 0 });

  const close = () => setOpen(false);

  const place = () => {
    const rect = buttonRef.current?.getBoundingClientRect();
    if (!rect) return;
    setPos({
      top: rect.bottom + 6,
      right: Math.max(8, window.innerWidth - rect.right),
    });
  };

  const toggle = () => {
    if (disabled) return;
    if (!open) place();
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (buttonRef.current?.contains(e.target)) return;
      if (menuRef.current?.contains(e.target)) return;
      close();
    };
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    window.addEventListener("mousedown", onDoc);
    window.addEventListener("scroll", close, true);
    window.addEventListener("resize", close);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("mousedown", onDoc);
      window.removeEventListener("scroll", close, true);
      window.removeEventListener("resize", close);
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const run = (action) => {
    close();
    action?.();
  };

  return (
    <div className="dd-offices__menu">
      <button
        ref={buttonRef}
        type="button"
        className="dd-hours__icon-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Office actions"
        disabled={disabled}
        onClick={toggle}
      >
        <FiMoreVertical size={16} aria-hidden />
      </button>
      {open && typeof document !== "undefined"
        ? createPortal(
            <div
              ref={menuRef}
              className="dd-offices__menu-panel"
              role="menu"
              style={{ top: pos.top, right: pos.right }}
            >
              <button type="button" role="menuitem" onClick={() => run(onAppointments)}>
                <FiCalendar size={14} aria-hidden />
                Appointments
              </button>
              <button type="button" role="menuitem" onClick={() => run(onHours)}>
                <FiClock size={14} aria-hidden />
                Hours
              </button>
              <button type="button" role="menuitem" onClick={() => run(onUsers)}>
                <FiUsers size={14} aria-hidden />
                Users
              </button>
              <button type="button" role="menuitem" onClick={() => run(onEdit)}>
                <FiEdit2 size={14} aria-hidden />
                Edit
              </button>
              <button
                type="button"
                role="menuitem"
                className="is-danger"
                onClick={() => run(onDelete)}
              >
                <FiTrash2 size={14} aria-hidden />
                Delete
              </button>
            </div>,
            document.body
          )
        : null}
    </div>
  );
}

export default OfficeRowMenu;
